import { API_URL } from "@/config/api";
import { API_TIMEOUT_MS, AppPathsEnum } from "@/constants/app.constants";
import { generateUUID } from "@/utils/uuid";
import axios, { AxiosError, AxiosInstance } from "axios";

const BASE_URL = API_URL + "/api/v1";
const REQUEST_ID_HEADER = "request-id";
const AUTH_PATHS = ["/user/profile/", "/web/"];

const isAuthPath = (url = ""): boolean =>
  AUTH_PATHS.some((path) => url.includes(path));

const applyInterceptors = (instance: AxiosInstance): AxiosInstance => {
  instance.interceptors.request.use((config) => {
    config.headers.set(REQUEST_ID_HEADER, generateUUID());
    return config;
  });

  instance.interceptors.response.use(
    (response) => response.data,
    (error: AxiosError) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.error("Authentication error:", error.response.status);
      }

      if (
        error.response?.status === 401 &&
        !isAuthPath(error.config?.url) &&
        window.location.pathname !== AppPathsEnum.LOGIN
      ) {
        window.location.href = AppPathsEnum.LOGIN;
      }

      if (!error.response) {
        console.error("Network error:", error.message);
      }

      return Promise.reject(error);
    }
  );
  return instance;
};

const createApiInstance = (prefix = ""): AxiosInstance =>
  applyInterceptors(
    axios.create({
      baseURL: `${BASE_URL}${prefix}`,
      withCredentials: true,
      timeout: API_TIMEOUT_MS,
      headers: {
        "Content-Type": "application/json",
      },
    })
  );

export const cmsApi = createApiInstance("/cms");

const api = createApiInstance();
export default api;
